/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/scandipwa
 * @link https://github.com/scandipwa/scandipwa
 */

import {
    CartQuery as SourceCartQuery
} from 'SourceQuery/Cart.query';
import { Field } from 'Util/Query';

/** @namespace Scandipwa/Query/Cart/Query */
export class CartQuery extends SourceCartQuery {
    getCartMwFeesQuery(cartId) {
        return new Field('cart')
            .setAlias('cartData')
            .addArgument('cart_id', 'String!', cartId)
            .addFieldList(this._getMageworxFields());
    }

    _getMageworxFields() {
        return [
            // new Field('mw_applied_product_fees')
            //     .addFieldList([
            //         'quote_item_id',
            //         this._getMageworxProductFees()
            //     ]),
            new Field('mw_applied_quote_fees')
                .addFieldList(this._getMageworxQuoteFees())
            // new Field('mw_cart_fees')
            //     .addFieldList(this._getMageworxSimpleFees()),
            // new Field('mw_shipping_fees')
            //     .addFieldList(this._getMageworxSimpleFees())
        ];
    }

    // _getMageworxSimpleFees() {
    //     return [
    //         'id',
    //         'title',
    //         'input_type',
    //         new Field('options')
    //             .addFieldList([
    //                 'id',
    //                 'title',
    //                 'field_label',
    //                 'price_type',
    //                 'price'
    //             ])
    //     ];
    // }

    _getMageworxQuoteFees() {
        return [
            'id',
            'title',
            new Field('price').addFieldList(['value', 'currency'])
            // this._getMageworxFeesOptions()
        ];
    }

    // _getMageworxFeesOptions() {
    //     return new Field('options')
    //         .addFieldList([
    //             'id',
    //             'title',
    //             new Field('price').addFieldList(['value', 'currency'])
    //         ]);
    // }

    // _getMageworxProductFees() {
    //     return new Field('fees')
    //         .addFieldList([
    //             'id',
    //             'title',
    //             new Field('price').addFieldList(['value', 'currency']),
    //             this._getMageworxFeesOptions()
    //         ]);
    // }
}

export default new CartQuery();
